import { useState } from 'react';
import SearchBar from 'components/searchBar/SearchBar';
import { CurrencyTableRow, CurrenciesTabSkeleton } from './components';
import useDebounce from 'hooks/useDebounce';
import { useCurrenciesTableListing } from 'hooks/useCurrencies';

import './currenciesTab.scss';

const CURRENCIES_TABLE_COLUMN_COUNT = 5;

/**
 * Tab de monedas con búsqueda, listado y scroll en el cuerpo de la tabla.
 */
const CurrenciesTab = () => {
  const [searchText, setSearchText] = useState<string>('');
  const debouncedSearchText = useDebounce(searchText, 800);
  const { currenciesTableListing, currenciesError, areCurrenciesLoading, mutateCurrenciesTableListing } =
    useCurrenciesTableListing(debouncedSearchText);

  const currencyList = currenciesTableListing || [];
  const hasError = !!currenciesError;
  const isEmptyList = currencyList.length === 0;

  /**
   * Renderiza una fila de estado dentro del cuerpo de la tabla.
   */
  const renderStateRow = (messageClassName: string, message: string) => (
    <tr className="currenciesTabStateRow">
      <td colSpan={CURRENCIES_TABLE_COLUMN_COUNT} className="currenciesTabStateCell">
        <span className={messageClassName}>{message}</span>
      </td>
    </tr>
  );

  const renderTableBodyContent = () => {
    if (areCurrenciesLoading) {
      return <CurrenciesTabSkeleton />;
    }

    if (hasError) {
      return renderStateRow(
        'currenciesTabErrorMessage',
        'Error cargando las monedas. Intenta nuevamente, si el problema persiste consulta a soporte.'
      );
    }

    if (isEmptyList) {
      return renderStateRow('currenciesTabEmptyMessage', 'No se encontraron monedas.');
    }

    return currencyList.map(item => (
      <CurrencyTableRow key={item.id} item={item} onExchangeRateSaved={mutateCurrenciesTableListing} />
    ));
  };

  return (
    <div className="currenciesTab">
      <div className="currenciesTabToolbar">
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          customPlaceholder="Busca por moneda o código"
        />
      </div>

      <div className="currenciesTabScroll">
        <table className="currenciesTabTable">
          <thead>
            <tr>
              <th className="currencyNameColumn">Nombre de la moneda</th>
              <th className="exchangeRateColumn">Tasa de cambio (USD)</th>
              <th className="lastUpdateColumn">Última actualización</th>
              <th className="updatedByColumn">Última actualización por</th>
              <th className="actionsColumn" />
            </tr>
          </thead>

          <tbody>{renderTableBodyContent()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default CurrenciesTab;
